export default "__VITE_ASSET__7661b4e2__"